// extracted by mini-css-extract-plugin
export var infoRow = "_tv-2";
export var labelContainer = "_tv-0";
export var rightInfo = "_tv-1";